interface DefaultArrowSelectProps {
  className?: string;
  color?: string;
}

const CircleChartIcon = ({ color, className }: DefaultArrowSelectProps) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill={color} className={className}>
        <path fillRule="evenodd" clipRule="evenodd" d="M8.5 0.5V7C8.5 7.27614 8.72386 7.5 9 7.5H15.5C15.7761 7.5 16 7.27614 16 7C16 3.13386 12.8661 0 9 0C8.72386 0 8.5 0.223858 8.5 0.5ZM14.9795 6.5H9.5V1.02053C12.415 1.26099 14.739 3.58498 14.9795 6.5ZM7.5 8.5V2.5C7.5 2.22386 7.27614 2 7 2C3.13386 2 0 5.13386 0 9C0 12.8661 3.13386 16 7 16C10.8661 16 14 12.8661 14 9C14 8.72386 13.7761 8.5 13.5 8.5H7.5ZM6.5 9C6.5 9.27614 6.72386 9.5 7 9.5H12.9795C12.7254 12.5799 10.1455 15 7 15C3.68614 15 1 12.3139 1 9C1 5.85452 3.42011 3.27459 6.5 3.02053V9Z" fill={color} />
      </svg>
    </>
  )
}

export default CircleChartIcon;